const EXPIRATION_SUFFIX = '_exp';

export const getCookieValue = (name: string) => {
    if (typeof document === 'undefined') {
        return null;
    }

    const cookies = document.cookie.split('; ');
    const cookie = cookies.find((row) => row.startsWith(`${name}=`));

    return cookie ? cookie.split('=')[1] : null;
};

/**
 * Sets 2 cookies:
 * one with the specified name, value, and expiration days,
 * and another with the same name with an _exp suffix, which its value is the expiration date.
 * The second cookie is needed in order to update the value of the first cookie, without changing its original expiration date.
 * In case we wouldn't want to change the value of the first cookie in the future, we can set only the first one.
 */
export const setCookieWithExpiration = (
    name: string,
    value: string | number | boolean,
    expirationDays: number,
    isTheValueMutable = true
) => {
    const date = new Date();
    date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
    const expireDate = date.toUTCString();

    document.cookie = `${name}=${value}; expires=${expireDate}; path=/`;

    if (isTheValueMutable) {
        document.cookie = `${name}${EXPIRATION_SUFFIX}=${expireDate}; expires=${expireDate}; path=/`;
    }
};

// Function to update only the value without changing expiration
export const updateCookieValue = (name: string, newValue: string | number | boolean) => {
    const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
        const [key, value] = cookie.split('=');
        acc[key] = value;
        return acc;
    }, {});

    if (cookies[name]) {
        document.cookie = `${name}=${newValue}; expires=${cookies[name + EXPIRATION_SUFFIX]}; path=/`;
    }
};
